/**
 * Convert a Supabase Storage public URL to an optimized render URL.
 * Uses Supabase Image Transformations (Pro plan) to resize, compress,
 * and auto-convert to WebP — dramatically reducing image payload.
 *
 * @param {string} url - Original Supabase storage public URL
 * @param {number} width - Target width (1-2500)
 * @param {number} height - Target height (1-2500)
 * @param {number} quality - JPEG/WebP quality (20-100, default 75)
 * @returns {string} Optimized render URL or original URL if not a Supabase storage URL
 */
export const getOptimizedImageUrl = (
  url,
  width = 500,
  height = 300,
  quality = 75,
) => {
  if (!url || typeof url !== "string") return url;
  // Only transform Supabase Storage public URLs
  if (!url.includes("/storage/v1/object/public/")) return url;
  return (
    url.replace(
      "/storage/v1/object/public/",
      "/storage/v1/render/image/public/",
    ) + `?width=${width}&height=${height}&resize=cover&quality=${quality}`
  );
};
